import { render, staticRenderFns } from "./LandingPosts.vue?vue&type=template&id=14a3d741&scoped=true&"
import script from "./LandingPosts.vue?vue&type=script&lang=js&"
export * from "./LandingPosts.vue?vue&type=script&lang=js&"
import style0 from "./LandingPosts.vue?vue&type=style&index=0&id=14a3d741&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a3d741",
  null
  
)

export default component.exports